





















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AInfo extends Vue {
  @Prop({
    required: false,
    default: true,
    type: Boolean,
  })
  public top!: boolean;

  @Prop({
    required: false,
    default: false,
    type: Boolean,
  })
  public bottom!: boolean;

  @Prop({
    required: false,
    default: false,
    type: Boolean,
  })
  public left!: boolean;

  @Prop({
    required: false,
    default: false,
    type: Boolean,
  })
  public right!: boolean;

  @Prop({
    required: false,
    default: 20,
    type: Number,
  })
  public size!: number;
}
